module.exports = "/_next/static/images/ThePayoff-xs-b63d7ca200ae09112fb98627e4a84337.webp";